import * as Yup from 'yup'
import { useClearOnUnmount, useFieldHelpers } from '@/base'
import { FormField, FormFieldProps } from '.'
import DatePicker, {
  DatePickerProps as BaseDatePickerProps,
} from '../date-picker'

export const FormDateInput = ({
  name,
  schema,
  shouldClearOnDismount,
  message,
  description,
  optionalText,
  ...rest
}: Omit<BaseDatePickerProps, 'value' | 'onChange'> &
  Omit<FormFieldProps, 'children'> & {
    schema?:
      | Yup.StringSchema<string | null | undefined>
      | Yup.DateSchema<Date | null | undefined>
    shouldClearOnDismount?: boolean
  }) => {
  const { field, helpers } = useFieldHelpers({ name, schema })
  useClearOnUnmount(shouldClearOnDismount, helpers.setValue)

  return (
    <FormField
      name={name}
      schema={schema}
      message={message}
      description={description}
      optionalText={optionalText}
    >
      <DatePicker
        {...rest}
        value={field.value}
        onChange={(value: string) => helpers.setValue(value)}
      />
    </FormField>
  )
}
